<template>
  <div class="home">
    <button type="button" @click="signOut()" class="sign-out">Sign Out</button>
    <CreateGateway />
    <div class="searchBar">
      <input type="text" name="searchQuery" id="searchQuery" v-model="searchQuery" placeholder="Enter a Email or Gateway ID..."/>
    </div>
    <GatewayList :searchQuery="searchQuery" />
    <v-dialog :clickToClose="false" />
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import GatewayList from "@/components/GatewayList.vue";
import CreateGateway from "@/components/CreateGateway.vue";
import Loading from "@/components/Loading.vue";
export default {
  name: "Main",
  data() {
    return {
      gateway_address: "",
      email_address: "",
      isSaving: false,
      searchQuery: ""
    }
  },
  components: {
    GatewayList,
    CreateGateway,
    Loading
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    },
    tokenExpired() {
      return this.$store.state.isTokenExpired
    }
  },
  methods: {
    signOut() {
      this.$store.state.loggedIn = false;
      localStorage.removeItem("idToken");
      this.$router.push("/logout");
    }
  },
  watch: {
    tokenExpired: function() {
      if (this.tokenExpired.expired === true) {
        this.$modal.show('dialog', {
          title: 'Error!',
          text: 'Token Expired! You will be redireced to SignIn page.',
          buttons: [
            {
              title: 'Confirm',
              handler: () => {
                this.signOut()
              }
            }
          ]
        });
      }
    }
  }
};
</script>
<style lang="scss">
.home {
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 800px;
  margin: auto;
  .searchBar {
    display: inline-flex;
  }
  button,
  input {
    border-radius: 5px;
    border: 1px solid #dbdbdb;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
    }
  }
  button {
    cursor: pointer;
    &.sign-out {
      background-color: #DD3F3F;
      color: white;
      width: fit-content;
      margin-left: auto;
    }
  }
  .vue-dialog {
    padding: 5px;
  }
  .vue-dialog-buttons {
    padding-top: 10px;
    button {
      margin-bottom: 0px;
      padding: 5px 10px;
    }
  }
}
</style>
